module.exports = __webpack_public_path__ + "static/chess_2-b70af900594e5ad647bfc007f7af1f02.png";